import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  async getLLMApiKeys({ commit, state }, query) {
    const headers = getTokenHeader();
    if (headers && state.selectedPrincipal?.id) {
      try {
        const response = await axios.get(
          `${env.prompts_api_client_url}api/eo-prompt/admin`,
          {
            params: {
              ...query,
              principal_id: state.selectedPrincipal.id
            },
            headers
          }
        );
        commit("SET_LLM_API_KEYS", response?.data);
      } catch (e) {
        await this.dispatch("createError", e);
      }
    }
  },
  async getLLMConfig({ commit, state }, query = {}) {
    const headers = getTokenHeader();
    if (headers && state.selectedPrincipal?.id) {
      try {
        const response = await axios.get(
          `${env.prompts_api_client_url}api/eo-prompt/config`,
          {
            params: {
              ...query,
              principal_id: state.selectedPrincipal.id
            },
            headers
          }
        );
        commit("SET_LLM_CONFIG", response?.data ?? {});
      } catch (e) {
        await this.dispatch("createError", e);
      }
    }
  },
  async getLLMVariables({ state }, query = {}) {
    const headers = getTokenHeader();
    const principalId = query.principal_id || state.selectedPrincipal?.id;

    if (headers && principalId) {
      try {
        const response = await axios.get(
          `${env.prompts_api_client_url}api/eo-prompt/variables`,
          {
            params: {
              ...query,
              principal_id: principalId
            },
            headers
          }
        );
        return response?.data ?? null;
      } catch (e) {
        await this.dispatch("createError", e);
        throw e;
      }
    }

    return null;
  },
  async getLLMPrompts({ state }, query = {}) {
    const headers = getTokenHeader();
    const principalId = query.principal_id || state.selectedPrincipal?.id;

    if (headers && principalId) {
      try {
        const response = await axios.get(
          `${env.prompts_api_client_url}api/eo-prompt/prompts`,
          {
            params: {
              ...query,
              principal_id: principalId
            },
            headers
          }
        );
        return Array.isArray(response?.data) ? response.data : [];
      } catch (e) {
        await this.dispatch("createError", e);
        throw e;
      }
    }

    return [];
  },
  async getLLMPromptPreview({ state }, query = {}) {
    const headers = getTokenHeader();
    const principalId = query.principal_id || state.selectedPrincipal?.id;
    const promptShortId = query.promptShortId;

    if (!headers || !promptShortId || !principalId) {
      return null;
    }

    try {
      const response = await axios.get(
        `${env.prompts_api_client_url}api/eo-prompt/prompt/preview`,
        {
          params: {
            promptShortId,
            principal_id: principalId,
            replacement: "visible"
          },
          headers
        }
      );
      return response?.data ?? null;
    } catch (e) {
      await this.dispatch("createError", e);
      throw e;
    }
  },
  async saveLLMVariables({ state }, variables) {
    const headers = getTokenHeader();
    const principalId = state.selectedPrincipal?.id;

    if (headers && principalId) {
      try {
        const response = await axios.put(
          `${env.prompts_api_client_url}api/eo-prompt/variables`,
          {
            principal_id: principalId,
            variables
          },
          { headers }
        );
        return response?.data ?? null;
      } catch (e) {
        await this.dispatch("createError", e);
        throw e;
      }
    }

    return null;
  }
};
